var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import filterXss from 'xss';
import 'url-search-params-polyfill';
import 'array-flat-polyfill';
import { toDateInputValue, isFri, isSat, isSun } from './date-helpers';
import { REASONS_TO_CLOSE, OTO_PRODUCTS } from '../config';
import { DeliveryTypes } from '../order-fields';
function parseAllowedBookingHours(raw) {
    if (raw == null)
        return undefined;
    if (Array.isArray(raw)) {
        return raw.map(function (h) { return String(h).trim(); }).filter(Boolean);
    }
    var s = String(raw).trim();
    if (!s)
        return undefined;
    return s.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
}
function parseAllowedBookingGuestsNumber(raw) {
    if (raw == null)
        return undefined;
    if (Array.isArray(raw)) {
        return raw
            .map(function (n) { return parseInt(String(n), 10); })
            .filter(function (n) { return !isNaN(n); });
    }
    var s = String(raw).trim();
    if (!s)
        return undefined;
    return s
        .split(',')
        .map(function (part) { return parseInt(part.trim(), 10); })
        .filter(function (n) { return !isNaN(n); });
}
export function getActiveReservationCustomRules(restaurant, restaurantProps) {
    var rules = restaurant.custom_rules;
    var peopleAmount = restaurantProps.peopleAmount, visitDate = restaurantProps.visitDate;
    if (!rules || !rules.map) {
        return [];
    }
    var activeCustomRulesWithKnownKeys = rules.map(function (rule) {
        var _a, _b;
        var key = rule.key, text = rule.text, value = rule.value, values = rule.values, disableBook = rule.disableBook;
        var allowedBookingHoursRaw = (_a = rule.allowedBookingHours) !== null && _a !== void 0 ? _a : rule.allowed_booking_hours;
        var allowedBookingHours = parseAllowedBookingHours(allowedBookingHoursRaw);
        var allowedBookingGuestsNumberRaw = (_b = rule
            .allowedBookingGuestsNumber) !== null && _b !== void 0 ? _b : rule
            .allowed_booking_guests_number;
        var allowedBookingGuestsNumber = parseAllowedBookingGuestsNumber(allowedBookingGuestsNumberRaw);
        var base = { text: text, disableBook: disableBook };
        if (allowedBookingHours === null || allowedBookingHours === void 0 ? void 0 : allowedBookingHours.length)
            Object.assign(base, { allowedBookingHours: allowedBookingHours });
        if (allowedBookingGuestsNumber === null || allowedBookingGuestsNumber === void 0 ? void 0 : allowedBookingGuestsNumber.length)
            Object.assign(base, { allowedBookingGuestsNumber: allowedBookingGuestsNumber });
        if (key === 'peopleAmount') {
            if (peopleAmount >= parseInt(value || '', 10)) {
                return base;
            }
        }
        if (key === 'visitDate') {
            if (values &&
                values.includes &&
                values.includes(toDateInputValue(visitDate))) {
                return base;
            }
        }
        if (key === 'isFri' && isFri(visitDate)) {
            return base;
        }
        if (key === 'isSat' && isSat(visitDate)) {
            return base;
        }
        if (key === 'isSun' && isSun(visitDate)) {
            return base;
        }
        if (key === 'disableBookMessage') {
            return base;
        }
        return null;
    });
    return activeCustomRulesWithKnownKeys.filter(function (rule) { return rule != null; });
}
export function getBookingRestrictionsForDate(restaurant, visitDate) {
    var e_1, _a;
    var _b, _c;
    var rules = getActiveReservationCustomRules(restaurant, {
        peopleAmount: 0,
        visitDate: visitDate,
    });
    var allowedHours = null;
    var allowedGuests = null;
    try {
        for (var rules_1 = __values(rules), rules_1_1 = rules_1.next(); !rules_1_1.done; rules_1_1 = rules_1.next()) {
            var rule = rules_1_1.value;
            if ((_b = rule.allowedBookingHours) === null || _b === void 0 ? void 0 : _b.length) {
                var hours = rule.allowedBookingHours;
                allowedHours = allowedHours ? __spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(allowedHours), false), __read(hours), false))), false) : __spreadArray([], __read(hours), false);
            }
            if ((_c = rule.allowedBookingGuestsNumber) === null || _c === void 0 ? void 0 : _c.length) {
                allowedGuests = allowedGuests
                    ? __spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(allowedGuests), false), __read(rule.allowedBookingGuestsNumber), false))), false) : rule.allowedBookingGuestsNumber;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (rules_1_1 && !rules_1_1.done && (_a = rules_1.return)) _a.call(rules_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return { allowedHours: allowedHours, allowedGuests: allowedGuests };
}
export function formatBookingRestrictionAlert(visitDate, allowedHours, allowedGuests) {
    var d = visitDate.getDate();
    var m = visitDate.getMonth() + 1;
    var y = visitDate.getFullYear();
    var dateStr = "".concat(String(d).padStart(2, '0'), ".").concat(String(m).padStart(2, '0'), ".").concat(y);
    var prefix = "Drodzy Go\u015Bcie, w dniu ".concat(dateStr, " restauracja przyjmuje rezerwacje ");
    if ((allowedHours === null || allowedHours === void 0 ? void 0 : allowedHours.length) && (allowedGuests === null || allowedGuests === void 0 ? void 0 : allowedGuests.length)) {
        return "".concat(prefix, "wy\u0142\u0105cznie o: ").concat(allowedHours.join(', '), " z mo\u017Cliwo\u015Bci\u0105 rezerwacji wy\u0142\u0105cznie dla ").concat(allowedGuests.join(' lub '), " Go\u015Bci.");
    }
    if (allowedHours === null || allowedHours === void 0 ? void 0 : allowedHours.length) {
        return "".concat(prefix, "wy\u0142\u0105cznie o: ").concat(allowedHours.join(', '), ".");
    }
    if (allowedGuests === null || allowedGuests === void 0 ? void 0 : allowedGuests.length) {
        return "".concat(prefix, "wy\u0142\u0105cznie dla ").concat(allowedGuests.join(' lub '), " Go\u015Bci.");
    }
    return '';
}
export function getActiveOrdersCustomRules(rules) {
    if (rules === void 0) { rules = []; }
    return (rules || [])
        .map(function (rule) {
        var key = rule.key, text = rule.text, values = rule.values, _a = rule.disableOrder, disableOrder = _a === void 0 ? true : _a;
        if (key === 'visitDate') {
            if (values &&
                values.includes &&
                values.includes(toDateInputValue(new Date()))) {
                return { text: text, disableOrder: disableOrder };
            }
        }
        return null;
    })
        .filter(function (rule) { return !!rule; });
}
export function isBookingPartner(restaurant) {
    var products = (restaurant || {}).products;
    return (products || []).includes(OTO_PRODUCTS.reservations);
}
export function hasOrders(restaurant) {
    var products = (restaurant || {}).products;
    return (products || []).includes(OTO_PRODUCTS.orders);
}
export function getOrdersConfig(restaurant) {
    return (restaurant.config && restaurant.config.orders) || {};
}
export function isPaused(restaurant) {
    return restaurant.status === 'blocked';
}
export function isTakeoutOrder(order) {
    return order.delivery_type === DeliveryTypes.takeout;
}
export function hasCustomDeliveryTime(order) {
    return order.customer && order.customer.deliveryAt;
}
export function getDisabledOrdersText(restaurant) {
    var ordersConfig = getOrdersConfig(restaurant);
    if (ordersConfig) {
        var value = ordersConfig.allowOrders;
        if (value && value !== true) {
            return ((REASONS_TO_CLOSE[value] && REASONS_TO_CLOSE[value].text) ||
                REASONS_TO_CLOSE.default.text);
        }
    }
    return false;
}
export function isDebugMode() {
    var urlParams = new URLSearchParams(filterXss(window.location.search));
    return urlParams.get('debug') === 'true';
}
